import { useEffect, useReducer } from 'react';

import axios from 'axios';

import { SETTINGS_API } from '../config/settingsConfig';
import { ClassSettings } from '../types/adminConfig';
import { getUrls } from '../utils/url';
import { transformSettingsData } from '../views/AdminSettings/utils/transformSettingsData';

let cache: ClassSettings | null = null;

interface ClassSettingsState {
    loading: boolean;
    error?: Error;
    data?: ClassSettings;
}

const initialState = {
    loading: true,
    error: undefined,
    data: undefined
};

type Action = { type: 'loading' } | { type: 'success'; payload: ClassSettings } | { type: 'error'; payload: Error };

const reducer = (state: ClassSettingsState, action: Action) => {
    switch (action.type) {
        case 'success':
            return { ...state, loading: false, data: action.payload };
        case 'error':
            return { ...state, loading: false, error: action.payload };
        case 'loading':
        default:
            return initialState;
    }
};

export const useOrgSettings = () => {
    const [state, dispatch] = useReducer(reducer, initialState);

    useEffect(() => {
        const { api } = getUrls();

        const url = `${api}${SETTINGS_API}`;

        dispatch({ type: 'loading' });

        if (cache) {
            dispatch({ type: 'success', payload: cache });
            return;
        }

        const getSettings = async () => {
            try {
                const { data: body } = await axios.get(url);
                const { data } = body;

                const settings = transformSettingsData(data);
                cache = settings;

                dispatch({ type: 'success', payload: settings });
            } catch (err) {
                console.error(err);

                dispatch({ type: 'error', payload: err as Error });
            }
        };

        getSettings();
    }, []);

    return { ...state };
};
